/**
 * Floating WhatsApp button — sits bottom-right on every page.
 * Tap opens WhatsApp with a pre-filled enquiry message.
 */
const PHONE = "919012302222";
// Note: encodeURIComponent leaves apostrophes un-encoded; we manually replace
// them with %27 so the resulting href matches the documented spec exactly.
const PREFILL = encodeURIComponent(
  "Hi Asia Sourcing — I'd like to start an enquiry."
).replace(/'/g, "%27");
const WA_URL = `https://wa.me/${PHONE}?text=${PREFILL}`;

export const WhatsAppButton = () => (
  <a
    href={WA_URL}
    target="_blank"
    rel="noopener noreferrer"
    className="wa-fab"
    aria-label="Chat with Asia Sourcing on WhatsApp"
    data-testid="whatsapp-fab"
  >
    <svg
      viewBox="0 0 32 32"
      width="28"
      height="28"
      aria-hidden="true"
      role="img"
      focusable="false"
    >
      <path
        fill="#fff"
        d="M16.003 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.25.59 4.45 1.71 6.39L3.2 28.8l6.59-1.72a12.74 12.74 0 0 0 6.21 1.6h.01c7.06 0 12.8-5.74 12.8-12.8 0-3.42-1.33-6.63-3.75-9.05a12.71 12.71 0 0 0-9.06-3.63zm0 23.36h-.01c-1.96 0-3.88-.53-5.56-1.52l-.4-.24-3.91 1.02 1.04-3.81-.26-.41a10.6 10.6 0 0 1-1.63-5.66c0-5.86 4.78-10.63 10.64-10.63 2.84 0 5.51 1.11 7.51 3.12a10.55 10.55 0 0 1 3.12 7.52c0 5.87-4.77 10.63-10.64 10.63zm5.83-7.96c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.51-.16-.72.16-.21.32-.83 1.04-1.02 1.26-.19.21-.37.24-.69.08-.32-.16-1.36-.5-2.59-1.6-.96-.86-1.6-1.92-1.79-2.24-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.72-1.74-.99-2.38-.26-.62-.53-.54-.72-.55l-.61-.01a1.18 1.18 0 0 0-.85.4c-.29.32-1.11 1.09-1.11 2.66 0 1.57 1.14 3.09 1.3 3.3.16.21 2.24 3.42 5.43 4.79.76.33 1.35.53 1.81.68.76.24 1.45.21 2 .13.61-.09 1.89-.77 2.16-1.51.27-.74.27-1.38.19-1.51-.08-.13-.29-.21-.61-.37z"
      />
    </svg>
    <span className="wa-label">WhatsApp</span>
  </a>
);

export default WhatsAppButton;
